// HELPERS
import {mergeViewStateForFulfillment} from "../../../Cob.helpers";

export default function (state, prevState)
{
	if (import.meta.env.VITE_CHECK_VIEW_FULFILLMENT === "0")
	{
		return true;
	}

	state = mergeViewStateForFulfillment(state, prevState);
	const {customerState} = state;

	if (customerState.radio_customer_has_help === "yes")
	{
		if (customerState.customer_current_help.length <= 0)
		{
			return false;
		}
	}

	if (customerState.customer_current_source === "Övrigt" && customerState.customer_current_source_other.length <= 0)
	{
		return false;
	}

	return true;
}